export default __webpack_public_path__ + "static/pauli_ayras-9d110964e90650f533cc0fd38484f449.png";